// App.tsx
import React from "react";
import { Provider } from "react-redux";
import store from "../src/store/store";
import AppRoutes from "./routes/routes";
import { AuthProvider } from "./context/AuthContext";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const queryClient = new QueryClient();

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
      </QueryClientProvider>
    </Provider>
  );
};

export default App;
